import {
  HOME_REMOVE_TEAM_MEMEBER_BEGIN,
  HOME_REMOVE_TEAM_MEMEBER_SUCCESS,
  HOME_REMOVE_TEAM_MEMEBER_FAILURE,
  HOME_REMOVE_TEAM_MEMEBER_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { builderAuthHeader, errorLogOut } from '../../common/utils/auth';
export function removeTeamMemeber(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_REMOVE_TEAM_MEMEBER_BEGIN,
    });
    const { projectId, uuid } = args;
    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}projects/team-member/${uuid}/project/${projectId}`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_REMOVE_TEAM_MEMEBER_SUCCESS,
            data: res,
          });
          resolve(res);
          if (res.data.status === 'success') {
            toast.success('Team member removed successfully');
          } else if (res.data.status === 'failed') {
            toast.error(res.data.message);
          } else {
            toast.error('Failed to remove team member');
          }
        },

        (err) => {
          dispatch({
            type: HOME_REMOVE_TEAM_MEMEBER_FAILURE,
            data: { error: err },
          });
          reject(err);
          if (err.response.status === 401) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Session Expired',
            }).then((result) => {
              if (result.value) {
                errorLogOut();
              }
            });
          } else {
            toast.error('Internal server error');
          }
        },
      );
    });

    return promise;
  };
}

export function dismissRemoveTeamMemeberError() {
  return {
    type: HOME_REMOVE_TEAM_MEMEBER_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_REMOVE_TEAM_MEMEBER_BEGIN:
      return {
        ...state,
        removeTeamMemeberPending: true,
        removeTeamMemeberError: null,
      };

    case HOME_REMOVE_TEAM_MEMEBER_SUCCESS:
      return {
        ...state,
        removeTeamMemeberPending: false,
        removeTeamMemeberError: null,
      };

    case HOME_REMOVE_TEAM_MEMEBER_FAILURE:
      return {
        ...state,
        removeTeamMemeberPending: false,
        removeTeamMemeberError: action.data.error,
      };

    case HOME_REMOVE_TEAM_MEMEBER_DISMISS_ERROR:
      return {
        ...state,
        removeTeamMemeberError: null,
      };

    default:
      return state;
  }
}
